<template>
  <div class="container">
    <van-swipe @change="onChange" :loop="false" width="100vw" height="60vw">
      <van-swipe-item v-for="item in imglist" :key="item.index">
        <img :src="item" alt="" />
      </van-swipe-item>
      <template #indicator>
        <div class="custom-indicator">{{ current + 1 }}/{{ total }}</div>
      </template>
    </van-swipe>
    <div class="main">
      <p class="title">{{ obj.title }}</p>
      <div class="flexdiv">
        <div>
          <span>{{ obj.org_name }}</span
          ><br />
          <span>{{ timeTrans(obj.createtime) }}发布</span>
        </div>
        <span>{{ obj.view_count }}次阅读</span>
      </div>
      <div class="margin">
        <p class="subtitle">活动时间：</p>
        <p class="desc">{{ obj.starttime }} 至 {{ obj.endtime }}</p>
      </div>
      <div class="margin">
        <p class="subtitle">活动地点：</p>
        <p class="desc">{{ obj.address }}</p>
      </div>
      <div class="margin">
        <p class="subtitle">活动内容：</p>
        <div class="desc" v-html="obj.content"></div>
      </div>
      <van-button
        type="warning"
        :loading="loading"
        loading-text="请稍候"
        v-if="obj.btn == 1"
        @click="baoming"
        >{{ obj.btn_str }}</van-button
      >
      <van-button
        type="warning"
        :loading="loading"
        loading-text="请稍候"
        v-if="obj.btn == 2"
        @click="sign('in', obj.needgis)"
        >{{ obj.btn_str }}</van-button
      >
      <van-button
        type="warning"
        :loading="loading"
        loading-text="请稍候"
        v-if="obj.btn == 3"
        @click="sign('out', obj.needgis)"
        >{{ obj.btn_str }}</van-button
      >
      <van-button
        type="warning"
        :loading="loading"
        loading-text="请稍候"
        v-if="obj.btn == 5"
        @click="unbaoming"
        >{{ obj.btn_str }}</van-button
      >
      <van-button
        type="warning"
        :loading="loading"
        loading-text="请稍候"
        v-if="obj.btn == 7"
        @click="tohomepage(obj.m_id)"
        >{{ obj.btn_str }}</van-button
      >
      <van-button
        type="warning"
        :loading="loading"
        loading-text="请稍候"
        v-if="obj.btn == 4 || obj.btn == 8"
        @click="urlchange(obj.id)"
        >{{ obj.btn_str }}</van-button
      >
      <van-overlay :show="show" @click="show = false">
        <div class="wrapper">
          <div class="block" @click.stop>
            <img
              src="static/img/zs03.png"
              style="width: 30%; display: block; margin: 0 auto"
              alt=""
            />
            <p style="text-align: center; padding: 10px 0">
              <span style="color: white; font-weight: bold">已解锁</span>
              <span style="color: orange; font-weight: bold"
                >《{{ zsname }}》</span
              >
            </p>
            <div
              style="
                width: 90%;
                margin: 0 auto;
                background: orange;
                border-radius: 15px;
              "
            >
              <img
                :src="zsimg"
                style="
                  width: 80%;
                  display: block;
                  margin: 0 auto;
                  padding: 20px 0;
                "
                alt=""
              />
              <div
                style="
                  background: white;
                  display: flex;
                  align-items: center;
                  line-height: 50px;
                  text-align: center;
                  border-radius: 0 0 15px 15px;
                "
              >
                <p
                  style="width: 50%; border-right: 1px solid #eee"
                  @click="$router.push('/eventcenterdetail')"
                >
                  确认
                </p>
                <p style="color: orange; width: 50%" @click="certlinkto()">
                  查看证书
                </p>
              </div>
            </div>
          </div>
        </div>
      </van-overlay>
    </div>
  </div>
</template>
<script>
export default {
  name: "detailqr",
  data() {
    return {
      obj: {},
      imglist: [],
      current: 0,
      state: "",
      total: 1,
      url: "",
      appId: "2312",
      lat: "", //用户地址
      lon: "",
      lattarget: "", //目标地址
      lngtarget: "",
      loading: false,
      skeloading: true,
      show: false,
      zsimg: "",
      zsname: "",
    };
  },
  created() {
    var that = this;
    this.url = "//zhuzhan.ijiangyin.com/siteapp/appClient/sign";
    var uid;
    if (!uid) {
      zjyapi.init({
        appId: that.appId,
        error: function (code, ret) {
          //失败回调,默认
          alert("初始化失败");
        },
        success: function success(ret) {
          that.queryLocation();
        },
      });
    } else {
      app.initUser({ uid: uid, mobile: mobile });
    }
    this.$axios({
      method: "post",
      url: "/api/task/detail",
      data: this.qs.stringify({
        token: sessionStorage.getItem("wmtoken"),
        id: this.$route.query.taskid,
      }),
    }).then((res) => {
      //console.log(res.data);
      if (res.data.code == 0) {
        this.obj = res.data.data.task;
        console.log(this.obj.content);
        console.log(typeof this.obj.content);
        this.lattarget = this.obj.lat;
        this.lngtarget = this.obj.lng;
        this.total = res.data.data.task_img.length;
        this.imglist = res.data.data.task_img;
        console.log(parseInt(new Date().getTime() / 1000));
        if (
          parseInt(new Date().getTime() / 1000) < this.obj.starttime ||
          parseInt(new Date().getTime() / 1000) > this.obj.endtime
        ) {
          //不在时间内
          this.state = "";
        } else if (!res.data.data.task_member) {
          this.state = 0;
        } else if (res.data.data.task_member.status == 1) {
          this.state = 1;
        } else if (res.data.data.task_member.status == 2) {
          this.state = 2;
        }
      } else {
        this.$toast(res.data.msg);
      }
    });
    this.$toast.loading({
      duration: 0,
      forbidClick: true,
    });
    this.$axios({
      method: "post",
      url: "/api/task/signupqr",
      data: this.qs.stringify({
        token: sessionStorage.getItem("wmtoken"),
        id: this.$route.query.taskid,
      }),
    }).then((res) => {
      this.$toast.clear();
      if (res.data.code == 0) {
        this.init();
      } else {
        this.$toast(res.data.msg);
      }
    });
  },
  updated() {
    let img = document.querySelectorAll(".desc img"); //获取所有图片
    for (let i = 0; i < img.length; i++) {
      const element = img[i];
      //添加样式
      element.style.width = "100%";
      element.style.margin = "10px auto";
      element.style.display = "block";
    }
  },
  methods: {
    tohomepage(id) {
      this.$router.push({
        name: "homepage",
        query: {
          id: id,
        },
      });
    },
    //签到签离相关
    getRad(d) {
      return (d * Math.PI) / 180.0; //经纬度转换成三角函数中度分表形式。
    },
    getFlatternDistance(lat1, lng1, lat2, lng2) {
      lat1 = parseFloat(lat1);
      lat2 = parseFloat(lat2);
      lng1 = parseFloat(lng1);
      lng2 = parseFloat(lng2);
      var f = this.getRad((lat1 + lat2) / 2);
      var g = this.getRad((lat1 - lat2) / 2);
      var l = this.getRad((lng1 - lng2) / 2);
      var sg = Math.sin(g);
      var sl = Math.sin(l);
      var sf = Math.sin(f);
      var PI = Math.PI;
      var EARTH_RADIUS = 6378137.0;
      var s, c, w, r, d, h1, h2;
      var a = EARTH_RADIUS;
      var fl = 1 / 298.257;

      sg = sg * sg;
      sl = sl * sl;
      sf = sf * sf;

      s = sg * (1 - sl) + (1 - sf) * sl;
      c = (1 - sg) * (1 - sl) + sf * sl;

      w = Math.atan(Math.sqrt(s / c));
      r = Math.sqrt(s * c) / w;
      d = 2 * w * a;
      h1 = (3 * r - 1) / 2 / c;
      h2 = (3 * r + 1) / 2 / s;

      return d * (1 + fl * (h1 * sf * (1 - sg) - h2 * (1 - sf) * sg));
    },

    //app相关开始
    //获取签名方法
    getSign: function (fun) {
      /*请求参数*/
      var paramObj = {
        httpUrl: this.url,
        type: "post",
        data: {
          appId: this.appId,
        },
      };
      /*请求调用*/
      this.httpRequest(paramObj, fun, function () {
        alert("获取签名失败错误");
      });
    },
    httpRequest: function (paramObj, fun, errFun) {
      var xmlhttp = null;
      /*创建XMLHttpRequest对象，
       *老版本的 Internet Explorer（IE5 和 IE6）使用 ActiveX 对象：new ActiveXObject("Microsoft.XMLHTTP")
       * */
      if (window.XMLHttpRequest) {
        xmlhttp = new XMLHttpRequest();
      } else if (window.ActiveXObject) {
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
      }
      /*判断是否支持请求*/
      if (xmlhttp == null) {
        alert("你的浏览器不支持XMLHttp");
        return;
      }
      /*请求方式，并且转换为大写*/
      var httpType = (paramObj.type || "GET").toUpperCase();
      /*数据类型*/
      var dataType = paramObj.dataType || "json";
      /*请求接口*/
      var httpUrl = paramObj.httpUrl || "";
      /*是否异步请求*/
      var async = paramObj.async || true;
      /*请求参数--post请求参数格式为：foo=bar&lorem=ipsum*/
      var paramData = paramObj.data || [];
      var requestData = "";
      for (var name in paramData) {
        requestData += name + "=" + paramData[name] + "&";
      }
      requestData =
        requestData == ""
          ? ""
          : requestData.substring(0, requestData.length - 1);
      console.log(requestData);
      /*请求接收*/
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
          /*成功回调函数*/
          //获取签名数据成功:{"serverTime":null,"error":"200","msg":"成功","data":{"appSign":"b37808616bda9d71e100e0971881101d","appId":"2312""timestamp":1575953679723},"map":null}
          console.log("获取签名数据成功:" + xmlhttp.responseText);
          var obj = JSON.parse(xmlhttp.responseText);
          var data = obj.data;
          fun({
            timestamp: data.timestamp,
            sign: data.appSign,
          });
        } else {
          /*失败回调函数*/
          errFun;
        }
      };
      /*接口连接，先判断连接类型是post还是get*/
      if (httpType == "GET") {
        xmlhttp.open("GET", httpUrl, async);
        xmlhttp.send(null);
      } else if (httpType == "POST") {
        xmlhttp.open("POST", httpUrl, async);
        //发送合适的请求头信息
        xmlhttp.setRequestHeader(
          "Content-type",
          "application/x-www-form-urlencoded"
        );
        xmlhttp.send(requestData);
      }
    },
    queryLocation: function () {
      var that = this;
      this.getSign(function (sign) {
        zjyapi.queryLocation({
          sign: sign,
          params: {
            type: "1",
          },
          success: function (ret) {
            console.log("获取用户定位信息成功：" + ret);
            var data = JSON.parse(ret);
            console.log(ret);
            console.log(data);
            that.lat = data.latitude;
            that.lon = data.longitude;
            that.skeloading = false;
          },
          error: function (error) {
            console.log("获取用户定位信息失败：" + JSON.stringify(error));
            that.skeloading = false;
          },
        });
      });
    },
    //end
    urlchange(id) {
      this.$router.push({
        name: "release",
        query: {
          id: id,
        },
      });
    },
    onChange(index) {
      console.log(index);
      this.current = index;
    },
    baoming() {
      this.loading = true;
      this.$axios({
        method: "post",
        url: "/api/task/signup",
        data: this.qs.stringify({
          id: this.$route.query.taskid,
          token: sessionStorage.getItem("wmtoken"),
        }),
      }).then((res) => {
        console.log(res.data);
        if (res.data.code == 0) {
          this.$toast("报名成功");
          this.$router.push("/eventcenterdetail");
        } else {
          this.$toast(res.data.msg);
        }
        this.loading = false;
      });
    },
    unbaoming() {
      this.loading = true;
      this.$axios({
        method: "post",
        url: "/api/task/unsignup",
        data: this.qs.stringify({
          id: this.$route.query.taskid,
          token: sessionStorage.getItem("wmtoken"),
        }),
      }).then((res) => {
        console.log(res.data);
        if (res.data.code == 0) {
          this.$toast("取消报名成功");
          this.$router.push("/eventcenterdetail");
        } else {
          this.$toast(res.data.msg);
        }
        this.loading = false;
      });
    },
    init() {
      this.$axios({
        method: "post",
        url: "/api/task/detail",
        data: this.qs.stringify({
          token: sessionStorage.getItem("wmtoken"),
          id: this.$route.query.taskid,
        }),
      }).then((res) => {
        //console.log(res.data);
        if (res.data.code == 0) {
          this.obj = res.data.data.task;
          console.log(this.obj.content);
          console.log(typeof this.obj.content);
          this.lattarget = this.obj.lat;
          this.lngtarget = this.obj.lng;
          this.total = res.data.data.task_img.length;
          this.imglist = res.data.data.task_img;
          console.log(parseInt(new Date().getTime() / 1000));
          if (
            parseInt(new Date().getTime() / 1000) < this.obj.starttime ||
            parseInt(new Date().getTime() / 1000) > this.obj.endtime
          ) {
            //不在时间内
            this.state = "";
          } else if (!res.data.data.task_member) {
            this.state = 0;
          } else if (res.data.data.task_member.status == 1) {
            this.state = 1;
          } else if (res.data.data.task_member.status == 2) {
            this.state = 2;
          }
        } else {
          this.$toast(res.data.msg);
        }
      });
    },
    sign(status, need) {
      if (this.skeloading) {
        this.$toast("正在获取您的位置，请稍候");
        return;
      }
      this.loading = true;
      if (status == "in") {
        //点击签到
        let distance = this.getFlatternDistance(
          this.lattarget,
          this.lngtarget,
          this.lat,
          this.lon
        );
        console.log(this.lattarget, this.lngtarget, this.lat, this.lon);
        console.log("distance:");
        console.log(distance);
        if (need == 1 && distance > 1000) {
          this.$toast("您离目标地点距离太远");
          this.loading = false;
        } else {
          this.$axios({
            method: "post",
            url: "/api/task/signin",
            data: this.qs.stringify({
              id: this.$route.query.taskid,
              token: sessionStorage.getItem("wmtoken"),
            }),
          }).then((res) => {
            console.log(res.data);
            this.loading = false;
            if (res.data.code == 0) {
              this.$toast("签到成功");
              this.$router.push("/eventcenterdetail");
            } else {
              this.$toast(res.data.msg);
            }
          });
        }
      }
      if (status == "out") {
        //点击签离
        let distance = this.getFlatternDistance(
          this.lattarget,
          this.lngtarget,
          this.lat,
          this.lon
        );
        console.log(this.lattarget, this.lngtarget, this.lat, this.lon);
        console.log("distance:");
        console.log(distance);
        if (distance > 1000 && need == 1) {
          this.$toast("您离目标地点距离太远");
          this.loading = false;
        } else {
          this.$axios({
            method: "post",
            url: "/api/task/signout",
            data: this.qs.stringify({
              id: this.$route.query.taskid,
              token: sessionStorage.getItem("wmtoken"),
            }),
          }).then((res) => {
            console.log(res.data);
            this.loading = false;
            if (res.data.code == 0) {
              this.$toast(res.data.msg);
              //this.$router.push('/eventcenterdetail');
              if (res.data.data.cert != "") {
                this.zsimg = res.data.data.cert;
                this.zsname = res.data.data.cert_name;
                this.init();
                this.show = true;
                this.$forceUpdate();
              } else {
                this.$router.push("/eventcenterdetail");
              }
            } else {
              this.$toast(res.data.msg);
            }
          });
        }
      }
    },
    certlinkto() {
      localStorage.setItem("zsimg", this.zsimg);
      this.$router.push("/zhengshudetail");
    },
  },
};
</script>
<style scoped>
img {
  width: 100%;
  display: block;
}
.main {
  padding: 20px;
}
.title {
  font-weight: bold;
  font-size: 18px;
}
.main .flexdiv {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #c4c4c4;
  margin: 10px 0;
}
.flexdiv div span {
  margin-right: 10px;
}
.margin {
  margin: 10px 0;
}
.subtitle {
  font-weight: bold;
}
.desc {
  color: #adacae;
  font-size: 14px;
  margin-top: 5px;
  white-space: pre-wrap;
}
.van-button {
  display: block;
  margin: 10px auto;
  background: #cab586;
  border-color: transparent;
}
.van-swipe {
  width: 100%;
  height: 60vw;
}
.van-swipe img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.custom-indicator {
  position: absolute;
  right: 5px;
  bottom: 5px;
  padding: 2px 5px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.1);
}
.van-button {
  width: 80%;
  display: block;
  margin: 20px auto;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 90%;
}
</style>


// WEBPACK FOOTER //
// src/components/detailqr.vue